import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getAggregateSaleTrend } from '@/service/sale/reportMortar';
export default function useMortarSaleTrend(params) {
  var aggregateSaleTrendData = ref([]);
  var aggregateSaleTrendYearData = ref([]);
  // 获取主机汇总数据
  var getAggregateSaleTrendAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var num, type, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            num = 30;
            type = 0;
            _context.t0 = params.value.type;
            _context.next = _context.t0 === 0 ? 5 : _context.t0 === 1 ? 8 : _context.t0 === 2 ? 11 : _context.t0 === 3 ? 14 : _context.t0 === 4 ? 17 : 20;
            break;
          case 5:
            num = 30;
            type = 0;
            return _context.abrupt("break", 20);
          case 8:
            num = 30;
            type = 1;
            return _context.abrupt("break", 20);
          case 11:
            num = 12;
            // num = 30
            type = 2;
            return _context.abrupt("break", 20);
          case 14:
            num = 3;
            // num = 12
            type = 3;
            return _context.abrupt("break", 20);
          case 17:
            num = 10;
            type = 4;
            return _context.abrupt("break", 20);
          case 20:
            _context.next = 22;
            return getAggregateSaleTrend({
              // ...params.value,
              // rangeType: params.value.type,
              // rangeNum: num
              date: params.value.date,
              type: type,
              rangeType: type,
              rangeNum: num
            });
          case 22:
            data = _context.sent;
            aggregateSaleTrendData.value = data.list;
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getAggregateSaleTrendAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var getAggregateSaleTrendYearAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAggregateSaleTrend({
              date: params.value.date,
              type: 3,
              rangeType: -1,
              rangeNum: 3
            });
          case 2:
            data = _context2.sent;
            aggregateSaleTrendYearData.value = data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getAggregateSaleTrendYearAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [aggregateSaleTrendData, aggregateSaleTrendYearData, getAggregateSaleTrendAsync, getAggregateSaleTrendYearAsync];
}